/* ByLumira theme — vanilla JS, no dependencies */
(() => {
  'use strict';
  const d = document, root = d.documentElement;
  root.classList.remove('no-js'); root.classList.add('js');
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const RTL = root.dir === 'rtl';
  const T = window.LM_STRINGS || {};
  const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const fmt = (cents) => {
    const f = window.LM_MONEY || '{{amount}}';
    const v = (cents / 100).toFixed(2);
    const noDec = (cents / 100).toFixed(0);
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, v);
  };
  const safeStore = {
    get(k, s = localStorage) { try { return s.getItem(k); } catch (e) { return null; } },
    set(k, v, s = localStorage) { try { s.setItem(k, v); } catch (e) {} }
  };

  /* ---------- Preloader ---------- */
  const pre = $('.lm-preloader');
  if (pre) {
    const seen = safeStore.get('lm_pre', window.sessionStorage);
    const finish = () => { pre.classList.add('is-done'); d.dispatchEvent(new CustomEvent('lm:ready')); setTimeout(() => pre.remove(), 900); };
    if (seen || RM) finish();
    else { safeStore.set('lm_pre', '1', window.sessionStorage); window.addEventListener('load', () => setTimeout(finish, 1500)); setTimeout(finish, 3800); }
  } else setTimeout(() => d.dispatchEvent(new CustomEvent('lm:ready')), 0);

  /* ---------- Toast ---------- */
  let toastEl, toastT;
  const toast = (msg) => {
    if (!toastEl) { toastEl = d.createElement('div'); toastEl.className = 'lm-toast'; toastEl.setAttribute('role', 'status'); d.body.appendChild(toastEl); }
    toastEl.innerHTML = '<span aria-hidden="true">✦</span> ' + msg;
    requestAnimationFrame(() => toastEl.classList.add('is-show'));
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-show'), 2600);
  };

  /* ---------- Header ---------- */
  const header = $('.lm-header');
  if (header && header.classList.contains('is-transparent')) {
    const main = $('#MainContent'); const first = main && main.firstElementChild;
    if (!first || !first.querySelector('.lm-hero')) header.classList.remove('is-transparent');
  }
  if (header) {
    let last = 0;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 30);
      if (header.dataset.hideOnScroll === 'true') header.classList.toggle('is-hidden', y > last && y > 400 && !d.body.classList.contains('lm-lock'));
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- Announcement rotator ---------- */
  $$('.lm-announce').forEach((bar) => {
    const items = $$('.lm-announce__item', bar); if (items.length < 2) return;
    let i = 0; const speed = (+bar.dataset.speed || 5) * 1000;
    setInterval(() => {
      const cur = items[i]; cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      setTimeout(() => cur.classList.remove('is-leaving'), 650);
      i = (i + 1) % items.length; items[i].classList.add('is-active');
    }, speed);
  });

  /* ---------- Drawers / modal ---------- */
  const overlay = $('.lm-overlay');
  let lastFocus;
  const openPanel = (id) => {
    const el = d.getElementById(id); if (!el) return;
    closeAll(); lastFocus = d.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-open'); d.body.classList.add('lm-lock');
    const f = el.querySelector('button, a, input'); f && setTimeout(() => f.focus(), 350);
  };
  const closeAll = () => {
    $$('.lm-drawer.is-open, .lm-modal.is-open').forEach((e) => { e.classList.remove('is-open'); e.setAttribute('aria-hidden', 'true'); });
    overlay && overlay.classList.remove('is-open'); d.body.classList.remove('lm-lock');
    $$('.lm-ugc video').forEach(v => v.pause());
  };
  d.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); openPanel(o.dataset.open); return; }
    if (e.target.closest('[data-close]') || e.target === overlay || e.target.classList.contains('lm-modal')) { closeAll(); lastFocus && lastFocus.focus && lastFocus.focus(); }
  });
  d.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });

  /* ---------- Language switcher ---------- */
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-locale]'); if (!b) return;
    const form = d.getElementById('LmLocalizationForm'); if (!form) return;
    form.querySelector('[name="locale_code"]').value = b.dataset.locale; form.submit();
  });

  /* ---------- Split text ---------- */
  $$('[data-split]').forEach((el) => {
    if (el.dataset.splitDone) return; el.dataset.splitDone = 1;
    const words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map((w, i) => `<span class="w"><span style="transition-delay:${(i * 0.07).toFixed(2)}s">${w}</span></span>`).join(' ');
    el.classList.add('lm-split');
  });

  /* ---------- Reveal on scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  const observeReveal = (ctx = d) => {
    $$('[data-reveal], .lm-split, .lm-img-reveal, .lm-step, .lm-scent__side', ctx).forEach((el) => io.observe(el));
    $$('[data-stagger]', ctx).forEach((wrap) => $$(':scope > *', wrap).forEach((c, i) => { c.style.setProperty('--d', (i % 8) * 0.08 + 's'); if (!c.hasAttribute('data-reveal')) { c.setAttribute('data-reveal', ''); io.observe(c); } }));
  };
  const startReveal = () => observeReveal();
  pre && !pre.classList.contains('is-done') ? d.addEventListener('lm:ready', startReveal, { once: true }) : startReveal();

  /* ---------- Parallax ---------- */
  const px = $$('[data-parallax]');
  if (px.length && !RM) {
    let ticking = false;
    const run = () => {
      px.forEach((el) => {
        const r = el.getBoundingClientRect(); const s = parseFloat(el.dataset.parallax) || 0.15;
        const off = (r.top + r.height / 2 - innerHeight / 2) * s * -1;
        el.style.transform = `translate3d(0,${off.toFixed(1)}px,0)`;
      }); ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true }); run();
  }

  /* ---------- Petals canvas (hero) ---------- */
  $$('canvas.lm-petals').forEach((cv) => {
    if (RM) return;
    const ctx = cv.getContext('2d'); let W, H, petals = [];
    const n = +cv.dataset.count || 18; const col = cv.dataset.color || '#F6C9CC';
    const size = () => { const r = cv.getBoundingClientRect(); W = cv.width = r.width * devicePixelRatio; H = cv.height = r.height * devicePixelRatio; };
    const mk = (init) => ({ x: Math.random() * W, y: init ? Math.random() * H : -30, r: (6 + Math.random() * 10) * devicePixelRatio, vy: (.25 + Math.random() * .6) * devicePixelRatio, vx: (Math.random() - .5) * .5 * devicePixelRatio, a: Math.random() * 6.28, va: (Math.random() - .5) * .02, o: .35 + Math.random() * .45, sw: Math.random() * 6.28 });
    size(); petals = Array.from({ length: n }, () => mk(true));
    let vis = true; new IntersectionObserver(([e]) => vis = e.isIntersecting).observe(cv);
    window.addEventListener('resize', size);
    const draw = () => {
      if (vis) {
        ctx.clearRect(0, 0, W, H);
        petals.forEach((p, i) => {
          p.sw += .015; p.x += p.vx + Math.sin(p.sw) * .6; p.y += p.vy; p.a += p.va;
          if (p.y > H + 30) petals[i] = mk(false);
          ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.globalAlpha = p.o;
          const g = ctx.createLinearGradient(-p.r, 0, p.r, 0); g.addColorStop(0, col); g.addColorStop(1, '#ffffff');
          ctx.fillStyle = g; ctx.beginPath();
          ctx.moveTo(0, -p.r); ctx.bezierCurveTo(p.r, -p.r * .6, p.r * .8, p.r * .7, 0, p.r); ctx.bezierCurveTo(-p.r * .8, p.r * .7, -p.r, -p.r * .6, 0, -p.r);
          ctx.fill(); ctx.restore();
        });
      }
      requestAnimationFrame(draw);
    };
    draw();
  });

  /* ---------- Sparkle cursor (desktop) ---------- */
  if (d.body.dataset.sparkle === 'true' && !RM && matchMedia('(hover:hover)').matches) {
    let lastT = 0;
    d.addEventListener('pointermove', (e) => {
      const now = performance.now(); if (now - lastT < 70) return; lastT = now;
      if (!e.target.closest('[data-sparkle-zone]')) return;
      const s = d.createElement('span'); s.className = 'lm-spark'; s.textContent = '✦';
      s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px'; s.style.fontSize = (8 + Math.random() * 10) + 'px';
      d.body.appendChild(s); setTimeout(() => s.remove(), 900);
    });
  }

  /* ---------- Ritual progress line ---------- */
  $$('.lm-ritual').forEach((sec) => {
    const line = $('.lm-ritual__line span', sec); if (!line) return;
    const upd = () => { const r = sec.getBoundingClientRect(); const p = Math.min(1, Math.max(0, (innerHeight * .8 - r.top) / (r.height * .7))); line.style.setProperty('--p', p.toFixed(3)); };
    window.addEventListener('scroll', upd, { passive: true }); upd();
  });

  /* ---------- Hotspots ---------- */
  d.addEventListener('click', (e) => {
    const h = e.target.closest('.lm-hotspot button'); if (!h) return;
    const w = h.parentElement; const open = w.classList.contains('is-open');
    $$('.lm-hotspot.is-open').forEach(x => x.classList.remove('is-open')); if (!open) w.classList.add('is-open');
  });

  /* ---------- Horizontal sliders ---------- */
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-slide]'); if (!b) return;
    const t = d.getElementById(b.dataset.target); if (!t) return;
    const dir = (b.dataset.slide === 'next' ? 1 : -1) * (RTL ? -1 : 1);
    t.scrollBy({ left: dir * t.clientWidth * .8, behavior: 'smooth' });
  });

  /* ---------- UGC video ---------- */
  d.addEventListener('click', (e) => {
    const it = e.target.closest('.lm-ugc__item'); if (!it) return;
    const v = it.querySelector('video'); if (!v) return;
    $$('.lm-ugc video').forEach(o => { if (o !== v) { o.pause(); o.closest('.lm-ugc__item').classList.remove('is-playing'); } });
    if (v.paused) { v.muted = false; v.play(); it.classList.add('is-playing'); } else { v.pause(); it.classList.remove('is-playing'); }
  });

  /* ---------- Accordion smooth ---------- */
  $$('details.lm-acc').forEach((det) => {
    const sum = det.querySelector('summary'); const body = det.querySelector('.lm-acc__body'); if (!body || RM) return;
    sum.addEventListener('click', (e) => {
      e.preventDefault();
      if (det.open) { const h = body.scrollHeight; body.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 380, easing: 'ease' }).onfinish = () => det.open = false; }
      else { det.open = true; const h = body.scrollHeight; body.animate([{ height: '0px' }, { height: h + 'px' }], { duration: 420, easing: 'ease' }); }
    });
  });

  /* =========================================================
     CART
     ========================================================= */
  const cartSections = () => $$('[data-cart-section]').map(e => e.dataset.cartSection).filter((v, i, a) => a.indexOf(v) === i);
  const renderSections = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      $$(`[data-cart-section="${id}"]`).forEach((target) => {
        const src = doc.querySelector(`[data-cart-section="${id}"]`); if (src) target.innerHTML = src.innerHTML;
      });
    });
    updateShipBar();
  };
  const updateCount = (count) => {
    $$('.lm-cart-count').forEach((c) => { c.textContent = count; c.classList.toggle('has-items', count > 0); c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); });
  };
  const updateShipBar = () => { $$('.lm-ship__bar span').forEach((s) => requestAnimationFrame(() => s.style.width = s.dataset.w + '%')); };
  const afterAdd = (data) => {
    renderSections(data.sections);
    fetch(R + 'cart.js').then(r => r.json()).then(c => updateCount(c.item_count));
    if ((window.LM_CART_TYPE || 'drawer') === 'drawer' && d.getElementById('CartDrawer')) openPanel('CartDrawer');
    else if (window.LM_CART_TYPE === 'page') window.location = R + 'cart';
    else toast(T.added || 'Added to your bag');
  };
  const cartAdd = (items, btn) => {
    btn && btn.classList.add('is-loading');
    return fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: cartSections(), sections_url: window.location.pathname }) })
      .then(r => r.json()).then((data) => {
        if (data.status && data.status !== 200) { toast(data.description || data.message || T.error || 'Error'); return; }
        afterAdd(data);
      }).catch(() => toast(T.error || 'Error')).finally(() => btn && btn.classList.remove('is-loading'));
  };
  window.LM = Object.assign(window.LM || {}, { cartAdd, toast, openPanel, closeAll });

  d.addEventListener('submit', (e) => {
    const f = e.target.closest('form[data-product-form]'); if (!f) return;
    e.preventDefault();
    const fd = new FormData(f); const id = fd.get('id'); const q = +(fd.get('quantity') || 1);
    const props = {}; for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; }
    cartAdd([{ id: +id, quantity: q, properties: props }], f.querySelector('[type="submit"]'));
  });
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-add]'); if (!b) return; e.preventDefault();
    cartAdd([{ id: +b.dataset.quickAdd, quantity: 1 }], b);
  });
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add-all]'); if (!b) return; e.preventDefault();
    const wrap = b.closest('[data-bundle]');
    const ids = $$('input[data-bundle-id]:checked', wrap).map(i => ({ id: +i.dataset.bundleId, quantity: 1 }));
    if (ids.length) cartAdd(ids, b);
  });
  d.addEventListener('change', (e) => {
    const c = e.target.closest('[data-bundle-price]'); if (!c) return;
    const wrap = c.closest('[data-bundle]'); const tot = $('[data-bundle-total]', wrap); if (!tot) return;
    const sum = $$('[data-bundle-price]', wrap).filter(i => i.checked).reduce((a, i) => a + (+i.dataset.bundlePrice || 0), 0);
    tot.textContent = fmt(sum); tot.animate([{ transform: 'scale(1.08)' }, { transform: 'none' }], { duration: 400, easing: 'ease-out' });
  });
  const changeLine = (line, quantity, el) => {
    const box = el && el.closest('.lm-drawer__body, .lm-cart-page'); box && (box.style.opacity = .55);
    return fetch(R + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity, sections: cartSections(), sections_url: window.location.pathname }) })
      .then(r => r.json()).then((c) => { if (c.status) { toast(c.message || T.error); return; } renderSections(c.sections); updateCount(c.item_count); })
      .finally(() => box && (box.style.opacity = 1));
  };
  d.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty]'); if (q) {
      const wrap = q.closest('.lm-qty'); const inp = wrap.querySelector('input');
      const v = Math.max(+inp.min || 0, (+inp.value || 0) + (q.dataset.qty === '+' ? 1 : -1)); inp.value = v;
      if (inp.dataset.line) changeLine(+inp.dataset.line, v, inp);
      return;
    }
    const rm = e.target.closest('[data-remove-line]'); if (rm) { e.preventDefault(); changeLine(+rm.dataset.removeLine, 0, rm); }
  });
  d.addEventListener('change', (e) => { const inp = e.target.closest('.lm-qty input[data-line]'); if (inp) changeLine(+inp.dataset.line, +inp.value, inp); });
  d.addEventListener('change', (e) => {
    const n = e.target.closest('[data-cart-note]'); if (!n) return;
    fetch(R + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: n.value }) });
  });
  updateShipBar();

  /* =========================================================
     PRODUCT PAGE
     ========================================================= */
  const initProduct = (scope) => {
    const dataEl = $('[data-product-json]', scope); if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = $('form[data-product-form]', scope);
    const idInput = form && form.querySelector('[name="id"]');
    const isMain = scope.dataset.main === 'true';
    const priceEl = $$('[data-price]', scope).concat(isMain ? $$('.lm-sticky-atc [data-price]') : []);
    const btns = $$('[data-atc-label]', scope).concat(isMain ? $$('.lm-sticky-atc [data-atc-label]') : []);

    const current = () => {
      const opts = $$('[data-option-index]', scope).map((fs) => { const c = fs.querySelector('input:checked') || fs.querySelector('select'); return c ? c.value : null; });
      return product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    };
    const markUnavailable = () => {
      $$('[data-option-index]', scope).forEach((fs) => {
        const idx = +fs.dataset.optionIndex;
        $$('input', fs).forEach((inp) => {
          const opts = $$('[data-option-index]', scope).map((f2) => { const c = f2.querySelector('input:checked'); return c ? c.value : null; });
          opts[idx] = inp.value;
          const v = product.variants.find(x => x.options.every((o, i) => o === opts[i]));
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };
    const updateWA = (v) => {
      $$('[data-wa-order]', scope).forEach((a) => {
        const msg = (a.dataset.waText || '') + ' ' + product.title + (v && v.title !== 'Default Title' ? ' — ' + v.title : '') + ' ' + window.location.origin + product.url + (v ? '?variant=' + v.id : '');
        a.href = 'https://wa.me/' + a.dataset.waOrder + '?text=' + encodeURIComponent(msg.trim());
      });
    };
    const onChange = () => {
      const v = current(); markUnavailable();
      $$('[data-selected-option]', scope).forEach((s) => { const fs = s.closest('[data-option-index]'); const c = fs && fs.querySelector('input:checked'); if (c) s.textContent = c.value; });
      if (!v) { btns.forEach(b => { b.disabled = true; b.querySelector('span') && (b.querySelector('span').textContent = T.unavailable || 'Unavailable'); }); return; }
      idInput && (idInput.value = v.id);
      priceEl.forEach(p => p.innerHTML = (v.compare_at_price > v.price ? `<s>${fmt(v.compare_at_price)}</s>` : '') + `<span>${fmt(v.price)}</span>`);
      $$('[data-tabby-amount]', scope).forEach(t => t.textContent = fmt(Math.round(v.price / 4)));
      btns.forEach((b) => { b.disabled = !v.available; const s = b.querySelector('span'); if (s) s.textContent = v.available ? (T.add || 'Add to bag') : (T.soldout || 'Sold out'); });
      $$('[data-sticky-variant]').forEach(s => s.textContent = v.title === 'Default Title' ? '' : v.title);
      $$('[data-sticky-id]').forEach(s => s.value = v.id);
      updateWA(v);
      if (v.featured_media) goToMedia(scope, v.featured_media.id);
      if (isMain) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    };
    scope.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) onChange(); });
    markUnavailable();
    updateWA(current() || product.variants[0]);

    // recently viewed
    if (isMain) {
      let rv = []; try { rv = JSON.parse(safeStore.get('lm_rv') || '[]'); } catch (e) {}
      rv = [product.handle].concat(rv.filter(h => h !== product.handle)).slice(0, 8);
      safeStore.set('lm_rv', JSON.stringify(rv));
    }
  };

  const goToMedia = (scope, mediaId) => {
    const slide = $(`[data-media-id="${mediaId}"]`, scope); if (!slide) return;
    const track = slide.parentElement; track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  };
  const initGallery = (g) => {
    const track = $('.lm-gallery__track', g); if (!track) return;
    const slides = $$('.lm-gallery__slide', g), thumbs = $$('.lm-gallery__thumbs button', g), dots = $$('.lm-gallery__dots span', g);
    const setActive = (i) => { thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); dots.forEach((t, k) => t.classList.toggle('is-active', k === i)); };
    const obs = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting && e.intersectionRatio > .6) setActive(slides.indexOf(e.target)); }), { root: track, threshold: [.6] });
    slides.forEach(s => obs.observe(s));
    thumbs.forEach((t, i) => t.addEventListener('click', () => { track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }));
    slides.forEach((s) => {
      const img = s.querySelector('img'); if (!img || !matchMedia('(hover:hover)').matches) return;
      s.addEventListener('click', () => s.classList.toggle('is-zoom'));
      s.addEventListener('mousemove', (e) => { if (!s.classList.contains('is-zoom')) return; const r = s.getBoundingClientRect(); img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`; });
      s.addEventListener('mouseleave', () => s.classList.remove('is-zoom'));
    });
  };
  $$('[data-product-scope]').forEach(initProduct);
  $$('.lm-gallery').forEach(initGallery);

  // Sticky add to cart
  const sticky = $('.lm-sticky-atc'), mainAtc = $('[data-main-atc]');
  if (sticky && mainAtc) {
    new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show); d.body.classList.toggle('has-sticky-atc', show);
    }).observe(mainAtc);
  }

  // Recently viewed rendering
  $$('[data-recently-viewed]').forEach((wrap) => {
    let rv = []; try { rv = JSON.parse(safeStore.get('lm_rv') || '[]'); } catch (e) {}
    const current = wrap.dataset.current; rv = rv.filter(h => h !== current).slice(0, 4);
    if (!rv.length) return;
    const grid = $('.lm-grid', wrap);
    Promise.all(rv.map(h => fetch(`${R}products/${h}?section_id=product-card-render`).then(r => r.ok ? r.text() : '').catch(() => ''))).then((htmls) => {
      const out = htmls.map(h => { const m = new DOMParser().parseFromString(h, 'text/html').querySelector('.lm-card'); return m ? m.outerHTML : ''; }).join('');
      if (out) { grid.innerHTML = out; wrap.hidden = false; observeReveal(wrap); }
    });
  });

  /* ---------- Quick view ---------- */
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-view]'); if (!b) return; e.preventDefault();
    const modal = d.getElementById('QuickView'); if (!modal) { location.href = b.dataset.quickView; return; }
    const box = $('.lm-modal__content', modal); box.innerHTML = '<div style="padding:80px;text-align:center">✦</div>';
    openPanel('QuickView');
    fetch(b.dataset.quickView + (b.dataset.quickView.includes('?') ? '&' : '?') + 'section_id=quick-view').then(r => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html'); const c = doc.querySelector('.lm-qv');
      box.innerHTML = c ? c.outerHTML : ''; const sc = $('[data-product-scope]', box); sc && initProduct(sc);
    });
  });

  /* =========================================================
     COLLECTION — AJAX filtering, sorting, density, load more
     ========================================================= */
  const coll = $('[data-collection]');
  if (coll) {
    const sectionId = coll.dataset.sectionId;
    const grid = () => $('.lm-coll-grid', coll);
    const load = (url, push = true) => {
      grid() && grid().classList.add('is-loading');
      const u = new URL(url, location.origin); u.searchParams.set('section_id', sectionId);
      fetch(u).then(r => r.text()).then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-coll-results]', '[data-coll-filters]', '[data-coll-active]', '[data-coll-count]'].forEach((sel) => {
          const a = $(sel, coll), b = doc.querySelector(sel); if (a && b) a.innerHTML = b.innerHTML;
        });
        if (push) { u.searchParams.delete('section_id'); history.pushState({}, '', u); }
        observeReveal(coll); applyDensity();
      });
    };
    const formUrl = () => {
      const f = $('#LmFilterForm'); const p = new URLSearchParams(new FormData(f));
      const s = $('[data-sort]', coll); s && s.value && p.set('sort_by', s.value);
      for (const [k, v] of [...p.entries()]) if (v === '') p.delete(k);
      return location.pathname + '?' + p.toString();
    };
    let ft;
    coll.addEventListener('change', (e) => {
      if (e.target.closest('#LmFilterForm') || e.target.matches('[data-sort]')) { clearTimeout(ft); ft = setTimeout(() => load(formUrl()), 300); }
    });
    coll.addEventListener('input', (e) => { if (e.target.matches('.lm-price-range input')) { clearTimeout(ft); ft = setTimeout(() => load(formUrl()), 700); } });
    coll.addEventListener('click', (e) => {
      const a = e.target.closest('[data-coll-active] a, [data-filter-clear]'); if (a) { e.preventDefault(); load(a.href); return; }
      const more = e.target.closest('[data-load-more]'); if (more) {
        e.preventDefault(); more.classList.add('is-loading');
        const u = new URL(more.href, location.origin); u.searchParams.set('section_id', sectionId);
        fetch(u).then(r => r.text()).then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newCards = $$('.lm-coll-grid > *', doc); const g = grid();
          newCards.forEach(c => g.appendChild(c));
          const a = $('[data-coll-more]', coll), b = doc.querySelector('[data-coll-more]'); if (a && b) a.innerHTML = b.innerHTML;
          observeReveal(g); applyDensity();
        });
      }
      const dz = e.target.closest('[data-density]'); if (dz) { safeStore.set('lm_density', dz.dataset.density); applyDensity(); }
    });
    const applyDensity = () => {
      const v = safeStore.get('lm_density') || coll.dataset.defaultCols || '3';
      const g = grid(); g && g.style.setProperty('--cols', v);
      $$('[data-density]', coll).forEach(b => b.classList.toggle('is-active', b.dataset.density === v));
    };
    applyDensity();
    window.addEventListener('popstate', () => load(location.href, false));
  }

  /* ---------- Scent quiz ---------- */
  $$('[data-quiz]').forEach((q) => {
    const steps = $$('.lm-quiz__step', q), bar = $('.lm-quiz__progress span', q); let i = 0; const score = { mystery: 0, cloud: 0 };
    const show = () => { steps.forEach((s, k) => s.classList.toggle('is-active', k === i)); bar.style.width = (i / steps.length * 100) + '%'; };
    q.addEventListener('click', (e) => {
      const o = e.target.closest('[data-vote]'); if (o) {
        score[o.dataset.vote]++; i++;
        if (i >= steps.length) {
          steps.forEach(s => s.classList.remove('is-active')); bar.style.width = '100%';
          const win = score.mystery >= score.cloud ? 'mystery' : 'cloud';
          $$('.lm-quiz__result', q).forEach(r => r.classList.toggle('is-active', r.dataset.result === win));
        } else show();
      }
      if (e.target.closest('[data-quiz-restart]')) { i = 0; score.mystery = score.cloud = 0; $$('.lm-quiz__result', q).forEach(r => r.classList.remove('is-active')); show(); }
    });
    show();
  });

  /* ---------- Magnetic buttons (desktop) ---------- */
  if (!RM && matchMedia('(hover:hover)').matches) {
    $$('[data-magnetic]').forEach((b) => {
      b.addEventListener('mousemove', (e) => { const r = b.getBoundingClientRect(); b.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * .18}px,${(e.clientY - r.top - r.height / 2) * .25}px)`; });
      b.addEventListener('mouseleave', () => b.style.transform = '');
    });
  }

  /* ---------- Count up ---------- */
  const cio = new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return; cio.unobserve(e.target);
    const el = e.target, to = parseFloat(el.dataset.count), suf = el.dataset.suffix || ''; if (isNaN(to)) return;
    const t0 = performance.now(), dur = 1600;
    const step = (t) => { const p = Math.min(1, (t - t0) / dur); el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))) + suf; if (p < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }), { threshold: .6 });
  $$('[data-count]').forEach(e => cio.observe(e));

  /* ---------- Theme editor support ---------- */
  d.addEventListener('shopify:section:load', (e) => {
    $$('[data-split]', e.target).forEach(el => { delete el.dataset.splitDone; });
    observeReveal(e.target); $$('[data-reveal], .lm-split, .lm-img-reveal', e.target).forEach(el => el.classList.add('is-in'));
    $$('.lm-gallery', e.target).forEach(initGallery); $$('[data-product-scope]', e.target).forEach(initProduct);
  });
})();
